import { ListeContainer, useListe } from '@mairistem/liste';
import React from 'react';

import SubventionListe from '@/src/components/SubventionListe/SubventionListe';

const SubventionListeContainer = () => {
	const [subventionService] = useListe('/api/finances/subventionsPercues');
	return (
		<ListeContainer
			type="subventions"
			contains="liste"
			service={subventionService}
			perPage={15}
		>
			<SubventionListe />
		</ListeContainer>
	);
};

export default SubventionListeContainer;
